import React, { useState } from "react";
import "./ImageGallery.css";

// const allImages = [
//   "/image1.jpg",
//   "/image2.jpg",
//   "/image3.jpg",
//   "/image4.jpg",
//   "/image5.jpg",
//   "/image6.jpg",
//   "/image7.jpg",
//   "/image8.jpg",
//   "/image9.jpg",
//   "/image10.jpg",
//   "/image11.jpg",
//   "/image12.jpg",
// ];

// const ImageGallery = () => {
//   const [visibleImages, setVisibleImages] = useState(3);

//   const loadMore = () => {
//     setVisibleImages((prev) => prev + 3);
//   };

//   return (
//     <div className="gallery-container">
//       <div className="gallery-grid">
//         {allImages.slice(0, visibleImages).map((image, index) => (
//           <img
//             key={index}
//             src={image}
//             alt={`Gallery ${index + 1}`}
//             className="gallery-image"
//           />
//         ))}
//       </div>
//       {visibleImages < allImages.length && (
//         <button onClick={loadMore} className="load-more-button">
//           LOAD MORE
//         </button>
//       )}
//     </div>
//   );
// };

const importAll = (requireContext) => requireContext.keys().map(requireContext);

const images = importAll(
  require.context("../public/gallery", false, /\.(jpg|jpeg|png)$/)
);

const ImageGallery = () => {
  const [visibleImages, setVisibleImages] = useState(3);

  const loadMore = () => {
    setVisibleImages((prev) => prev + 3);
  };

  return (
    <div className="gallery-container">
      <div className="gallery-grid">
        {images.slice(0, visibleImages).map((image, index) => (
          <img
            key={index}
            src={image}
            alt={`Gallery ${index + 1}`}
            className="gallery-image"
            loading="lazy"
          />
        ))}
      </div>
      {visibleImages < images.length && (
        <button onClick={loadMore} className="load-more-button">
          LOAD MORE
        </button>
      )}
    </div>
  );
};

export default ImageGallery;
